import React, { Component } from 'react';

import Navbar from './../Navbar/navbar.jsx';
import Navigation from './../Navigation/navigation.jsx';
import './getUsers.css';

import actions from './../../store/Actions/index.js';
import { withRouter }  from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { isLogin } from './../../utils/authentication.js';

class GetUsers extends Component{
    state = {
        userList:""
    }
    async componentDidMount() {
        if(!isLogin()){
            this.props.history.push({
                pathname:"/login"
            });
        }
        await this.props.getUsers();
        this.setState({userList:this.props.auth.getUsers});
    }

    onClick =async(userId) => {
        await this.props.deleteUser({userId:userId});
        this.props.history.push({
            pathname:"/"
        })
    }
    
    render(){
        return(
            <div>
                <div className="col-md-12">
                    <Navbar />
                    <Navigation />
                </div>
                <div className="col-md-12 pageBg">
                     <div className="col-md-8 offset-md-2">
                        {this.state && this.state.userList && this.state.userList.map((list, index) => (
                            <div key={list._id} className="userlist row">
                                <div className="col-md-8">
                                    {list.email}
                                </div>
                                <div className="dltBtn col-md-4">
                                    <Button varient="primary" type="submit" onClick={this.onClick.bind(this,list._id)}>
                                        Delete
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    auth:state.auth
});

const mapDispatchToProps = dispatch => ({
    getUsers:(v) => dispatch(actions.getUsers(v)),
    deleteUser:(v) => {dispatch(actions.deleteUser(v))}
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(GetUsers));


// WEBPACK FOOTER //
// ./src/components/GetUsers/getUsers.jsx